<template>
  <MarketCard class="market-insights">
    <CardHeader :eventId="eventId" />
    <div :class="classes.content">
      <div :class="classes.leftContent">
        <EventNameFitted
          :class="[classes.eventName, 'event-name']"
          :eventId="eventId"
          alignment="flex-start"
        />

        <div :class="[classes.promoWrapper]">
          <promo-fitted-text
            :promoText="insightText"
            alignment="flex-start"
          ></promo-fitted-text>
        </div>
      </div>

      <div :class="classes.rightContent">
        <MarketName :marketId="marketId" />

        <div :class="classes.oddsButtonWrapper">
          <template v-if="relevantOption">
            <RelevantButton
              :class="[classes.oddsButton]"
              :option="relevantOption"
              :eventId="eventId"
            ></RelevantButton>
          </template>
          <template v-else>
            <Button
              :stagger="0"
              :class="[classes.oddsButton]"
              :option="firstOption"
            />
            <Button
              :stagger="2"
              :class="[classes.oddsButton]"
              :option="secondOption"
            />
          </template>
        </div>
      </div>
    </div>
  </MarketCard>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { createUseStyles } from "@fresh8/ad-data-composition/src/theme";
import { useInsightData } from "../../../hooks/useInsightData";

import MarketCard from "../../styled/MarketCard.vue";
import CardHeader from "../../CardHeader.vue";
import EventNameFitted from "../../EventNameFitted.vue";
import Button from "./Button.vue";
import MarketName from "../../MarketName.vue";
import PromoFittedText from "../../PromoFittedText.vue";
import RelevantButton from "./RelevantButton.vue";

const { useStyles } = createUseStyles(
  {
    content: {
      display: "flex",
      flex: 1
    },
    leftContent: {
      flex: 1,
      padding: "6px 0 6px 6px",
      display: "flex",
      flexDirection: "column"
    },
    rightContent: {
      flex: "0 2 20%",
      display: "flex",
      flexDirection: "column",
      padding: "6px",
      minWidth: "95px"
    },
    eventName: {
      textAlign: "left",
      fontSize: "13px",
      boxSizing: "border-box",
      display: "flex",
      "&.event-name > div, &.event-name": {
        alignItems: "flex-start",
        justifyContent: "flex-start",
        textAlign: "left"
      }
    },
    promoWrapper: {
      flex: "1 1 0",
      minHeight: "0px",
      overflow: "hidden",
      boxSizing: "border-box",
      flexDirection: "column",
      display: "flex"
    },
    logoWrapper: {
      display: "flex",
      marginBottom: "4px"
    },
    oddsButtonWrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      flex: 1
    },
    oddsButton: {
      flex: 1,
      height: "25px",
      marginTop: "4px",
      "& .relevant-button": {
        flexDirection: "column",
        textAlign: "center",
        justifyContent: "center",
        "& .name": {
          fontSize: "12px"
        },
        "& .odds-text": {
          lineHeight: 1.4
        }
      },

      "& .odds-text": {
        fontSize: "12px"
      }
    },
    resize: {
      pointerEvents: "none",
      zIndex: -99
    }
  },
  undefined
);

export default defineComponent({
  name: "PromoCard",
  components: {
    MarketCard,
    CardHeader,
    EventNameFitted,
    Button,
    PromoFittedText,
    MarketName,
    RelevantButton
  },
  props: {
    marketId: { type: String, required: true },
    eventId: { type: String, required: true }
  },
  setup(props) {
    const { classesRef } = useStyles(ref({}));
    const {
      insightText,
      firstOption,
      secondOption,
      relevantOption
    } = useInsightData(props.marketId);

    return {
      insightText,
      firstOption,
      secondOption,
      relevantOption,
      classes: classesRef
    };
  }
});
</script>
